import { daysOfWeek, InputType, monthOption } from 'config'

export enum RepeatType {
  NoRepeat = 'noRpeat',
  Repeat = 'repeat',
}

export enum IntervalType {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
}

export const RepeatTypeOptions: Record<string, string> = {
  [RepeatType.NoRepeat]: 'Do not repeat',
  [RepeatType.Repeat]: 'Repeat',
}

export const IntervalOptions: Record<string, string> = {
  [IntervalType.Day]: 'Day',
  [IntervalType.Week]: 'Week',
  [IntervalType.Month]: 'Month',
  [IntervalType.Year]: 'Year',
}

export const IntevalLabels: Record<string, string> = {
  [IntervalType.Day]: 'Daily',
  [IntervalType.Week]: 'Weekly',
  [IntervalType.Month]: 'Monthly',
  [IntervalType.Year]: 'Yearly',
}

export const WeekOrdOfMonths: Record<string, string> = {
  '1': 'First',
  '2': 'Second',
  '3': 'Third',
  '4': 'Fourth',
  '-1': 'Last',
}

export const hourOptions: Record<string, string> = {
  '0': '00',
  '1': '01',
  '2': '02',
  '3': '03',
  '4': '04',
  '5': '05',
  '6': '06',
  '7': '07',
  '8': '08',
  '9': '09',
  '10': '10',
  '11': '11',
  '12': '12',
  '13': '13',
  '14': '14',
  '15': '15',
  '16': '16',
  '17': '17',
  '18': '18',
  '19': '19',
  '20': '20',
  '21': '21',
  '22': '22',
  '23': '23',
}

export const minuteOptions: Record<string, string> = {
  '0': '00',
  '15': '15',
  '30': '30',
  '45': '45',
}

export const defaultFrequencyInputs = (): Record<string, InputType> => {
  return {
    repeatType: {
      inputType: 'select',
      title: 'Repeat Type',
      options: RepeatTypeOptions,
      required: true,
      span: 2,
      value: RepeatType.NoRepeat,
    },
    custom1: {
      inputType: 'custom',
      title: '',
      span: 2,
    },
    startDate: {
      inputType: 'text',
      type: 'date',
      title: 'Start Date',
      required: true,
      span: 2,
    },
    endDate: {
      inputType: 'text',
      type: 'date',
      title: 'End Date',
      required: false,
      span: 2,
    },
    hour: {
      inputType: 'select',
      title: 'Hour',
      options: hourOptions,
      required: true,
      hasDefaultOption: true,
      span: 2,
    },
    minute: {
      inputType: 'select',
      title: 'Minute',
      options: minuteOptions,
      hasDefaultOption: true,
      required: true,
      span: 2,
    },
    repeatEvery: {
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      title: 'Repeat Every',
      value: 1,
      required: true,
      span: 2,
    },
    intervalUnit: {
      inputType: 'select',
      title: 'Interval Unit',
      options: IntervalOptions,
      required: true,
      value: IntervalType.Day,
      span: 2,
    },
  }
}

export const monthCustomOptionInputs = (): Record<string, InputType> => {
  return {
    monthType: {
      inputType: 'radio',
      title: '',
      options: {
        date: 'On day',
        day: 'On the',
      },
      noBorder: true,
      isPlain: true,
      required: true,
      visible: true,
      span: 'full',
    },
    dateOfMonth: {
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      title: 'Date Of Month',
      required: true,
      visible: false,
      span: 2,
    },
    weekOrdOfMonth: {
      inputType: 'select',
      title: 'Week Order',
      options: WeekOrdOfMonths,
      hasDefaultOption: true,
      required: true,
      visible: false,
      span: 2,
    },
    weekDayOfMonth: {
      inputType: 'select',
      title: 'Day Of Week',
      options: daysOfWeek,
      hasDefaultOption: true,
      required: true,
      visible: false,
      span: 2,
    },
  }
}

export const yearCustomOptionInputs = (): Record<string, InputType> => {
  return {
    yearType: {
      inputType: 'radio',
      title: '',
      options: {
        date: 'On',
        day: 'On the',
      },
      noBorder: true,
      isPlain: true,
      required: true,
      visible: true,
      span: 'full',
    },
    monthOfDateYear: {
      inputType: 'select',
      title: 'Month',
      options: monthOption,
      hasDefaultOption: true,
      required: true,
      visible: false,
      span: 2,
    },
    dateOfDateYear: {
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      title: 'Date Of Month',
      required: true,
      visible: false,
      span: 2,
    },
    weekOrdOfYear: {
      inputType: 'select',
      title: 'Week Order',
      options: WeekOrdOfMonths,
      hasDefaultOption: true,
      required: true,
      visible: false,
      span: 1,
    },
    weekDayOfYear: {
      inputType: 'select',
      title: 'Day Of Week',
      options: daysOfWeek,
      hasDefaultOption: true,
      required: true,
      visible: false,
      span: 1,
    },
    monthOfDayYear: {
      inputType: 'select',
      title: 'Month',
      options: monthOption,
      hasDefaultOption: true,
      required: true,
      visible: false,
      span: 2,
    },
  }
}
